import { SvgTypesProps } from '@/shared/types/SvgTypes';

export function IconGarrys({
  fill = 'var(--level-1)',
  width = 18,
  height = 18,
  className
}: SvgTypesProps & {className?: string}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 48 48" width={width} height={height} className={className}><path fill="#2196f3" d="M42,37c0,2.762-2.238,5-5,5H11c-2.761,0-5-2.238-5-5V11c0-2.762,2.239-5,5-5h26c2.762,0,5,2.238,5,5	V37z"/><path fill="#fff" d="M28,11v1.771C26.7,11.663,25.016,11,23,11c-5,0-8,3-8,9s3,9,8,9c2.016,0,3.7-0.663,5-1.771V30	c0,1.894-1.791,3.429-4,3.429S20,31.894,20,30h-5c0,4.418,4.029,8,9,8s9-3.582,9-8V11H28z M24,25c-2.209,0-4-2.239-4-5s1.791-5,4-5	s4,2.239,4,5S26.209,25,24,25z"/></svg>
  );
}
